import { NetworkActionPrefix } from '../utils/constants';
import defaults from '../api/defaults';
import { pipeReducers, networkObjectLoadReducer, combineReducers, networkEntityAddReducer, networkEntityEditReducer } from '../utils/reducerFactory';

function index(state, action, id) {
    return id !== undefined ? (id = state.getIndexByID(id)) !== -1 ? id : state.length : undefined;
}

const keyVariables = {
    personalTopicIndex: (state, action) => index(state, action, action.personalTopicID)
};

export default pipeReducers(
    networkObjectLoadReducer(NetworkActionPrefix.LOAD_PERSONAL_TOPIC_LIST_PREFIX, defaults.NetworkArray),
    combineReducers({
        Data: combineReducers({
            '@personalTopicIndex': pipeReducers(
                networkEntityAddReducer(NetworkActionPrefix.ADD_PERSONAL_TOPIC_PREFIX, null, (state, action) => action.personalTopic),
                networkEntityEditReducer(NetworkActionPrefix.EDIT_PERSONAL_TOPIC_PREFIX, null, (state, action) => action.personalTopic)
            )
        }, keyVariables)
    }, keyVariables)
);
